import { createContext, useContext, type ReactNode } from 'react';
import { useParams } from 'react-router';

const TimesheetRouteIdContext = createContext<string | undefined>(undefined);

/** When rendering a timesheet outside `/pending-timesheets/:id`, wrap with this provider. */
export function TimesheetRouteIdProvider({
  timesheetId,
  children,
}: {
  timesheetId: string;
  children: ReactNode;
}) {
  return (
    <TimesheetRouteIdContext.Provider value={timesheetId}>{children}</TimesheetRouteIdContext.Provider>
  );
}

/** Route param `id`, or override from {@link TimesheetRouteIdProvider} (month stacked view). */
export function useTimesheetRouteId(): string {
  const override = useContext(TimesheetRouteIdContext);
  const { id } = useParams();
  return override ?? id ?? '';
}
